import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class ExchangeScanActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  protected canRunOnCompanionRecords = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (!ProtectedEntitiesHelper.isUnifiedClient(record)) {
      return false;
    }

    if (!record.specifics.isExchangeServer) {
      return false;
    }

    if (!record.specifics.canRunExchangeScanTasks) {
      return false;
    }

    return true;
  }
}
